module.exports = __webpack_public_path__ + "static/srd3-ee173cc6368ca94b022d32a9e4b0223c.jpg";